/**
 * @file TrainingPortal.jsx
 *
 * @author - (Meera,Keerthana,Bhavithra)
 * @sprint - B2W-Sprint-6
 * @description -
 * This component manages the Training process from admon side
 *
 */

import React, { useState, useEffect } from "react";
// import { useParams } from 'react-router-dom';
import { Button, notification,Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Layout from "../../component/Layout";
import AdminTrainingCreateEditForm from "../../components/TrainingPortal/AdminTrainingCreateEditForm";
import AdminTrainingListView from "../../components/TrainingPortal/AdminTrainingListView";
import store from "../../redux/store";
import {updateTraining, deleteTraining,addTraining,getTraining,convertTo24HourFormat,formatTimeArray } from "../../services/Service";
import { showErrorNotification, showNotification } from "../../util/documentConfig";
import TrainingLabels from "./TrainingLabels.json";


const TrainingPortal = () => {
  const [visible, setVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);

    useEffect(() => {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "auto";
      };
    }, []);

  const token = store.getState().auth.token;
  if (!token) {
    throw new Error("No token found. User not authenticated.");
  }



  const fetchData = async () => {
    setLoading(true); // Start loading
    try {
      const response = await getTraining(token);
     
      // Check for 404 status code explicitly
      if (response.status === 404) {
        console.log("Training data not found (404).");
        setFilteredData([]);  // Set the filtered data to an empty array
        return;
      }
  
      // Check if response.data is an array and has at least one element
      if (Array.isArray(response.data) && response.data.length > 0) {
        // Format the start and end times
        const updatedData = response.data.map(trainingData => {
          const formattedStartTime = formatTimeArray(trainingData.startTime);
          const formattedEndTime = formatTimeArray(trainingData.endTime);
  
          return {
            ...trainingData,
            startTime: formattedStartTime,
            endTime: formattedEndTime
          };
        });
  
        setFilteredData(updatedData);
        console.log("Formatted Data:", updatedData);
      } else {
        console.error("Invalid or empty response data:", response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredData([]);  // Handle any error by resetting the data
    }
    finally {
      setLoading(false); // End loading
    }
  };
  

  useEffect(() => {
    fetchData();
  }, []);

  


  const showModal = () => {
    setSelectedRecord(null); // Reset selection for new entry
    setVisible(true);
  };

  const loadFormData = async(record) => {
    setSelectedRecord(record);
    setVisible(true);
  };



  /**
   * Handles the creation of a new record.
   * @param {Object} data - Form values submitted by the user.
   */
  const onCreate = async (data) => {

    console.log("RAW trainingTime:", data.trainingTime);
    const trainingStartTime = convertTo24HourFormat(data.trainingTime.start);
    const trainingEndTime = convertTo24HourFormat(data.trainingTime.end);

    const transformedData = {
      ...data,
      trainingStartDate: data.trainingDate?.start,
      trainingEndDate: data.trainingDate?.end,
      startTime: trainingStartTime,
      endTime: trainingEndTime,
    };

    // Optionally remove nested objects to avoid sending unnecessary fields
    delete transformedData.trainingDate;
    delete transformedData.trainingTime;

    console.log("---------------------transformed data", transformedData);
    try {

      const response = await addTraining( transformedData, token);

      // Check if the response is successful (status code 200-299)
      if (response.status >= 200 && response.status < 300) {
        console.log('Training saved successfully:', response.data);
        showNotification(TrainingLabels.Training_Success_Message);
      } else {
        console.error('Failed to save training:', response);
      }
      fetchData();
    }
    catch (error) {
      // Handle any errors from the API request
      console.error('Error saving training:', error);
      showErrorNotification(TrainingLabels.Training_Error_Message);
    }
  };

  /**
    * Handles deleting a record.
    * @param {Object} record - The record to delete.
    */


  const onDelete = async (record) => {
    if (!record?.id) {
      console.error("❌ No ID found on record");
      return;
    }

    try {
      await deleteTraining(record.id, token);

      showNotification(TrainingLabels.Training_Delete_Success_Message);

      fetchData();

    } catch (error) {
      console.error("Error deleting record:", error);
      showErrorNotification(TrainingLabels.Training_Delete_Failure_Message);
     
    }
  };
  
  
const onEdit = async (data) => {
    console.log("RAW trainingTime:", data.trainingTime);
    const trainingStartTime = convertTo24HourFormat(data.trainingTime.start);
    const trainingEndTime = convertTo24HourFormat(data.trainingTime.end);
  
    const transformedData = {
      ...data,
      trainingStartDate: data.trainingDate?.start,
      trainingEndDate: data.trainingDate?.end,
      startTime: trainingStartTime,
      endTime: trainingEndTime,
    };
  
    // Optionally remove nested objects to avoid sending unnecessary fields
    delete transformedData.trainingDate;
    delete transformedData.trainingTime;
  
    console.log("---------------------transformed data", transformedData);
    try {
    const response = await updateTraining(data.id, transformedData, token);
  
  
      // Check if the response is successful (status code 200-299)
      if (response.status >= 200 && response.status < 300) {
        console.log('Training updated successfully:', response.data);
        showNotification(TrainingLabels.Training_Update_Success_Message);
      } else {
        console.error('Failed to update training:', response);
      }
      fetchData();
    } catch (error) {
      // Handle any errors from the API request
      console.error('Error updating training:', error);
      showErrorNotification(TrainingLabels.Training_Update_Failure_Message);
    }
  };
  

  return (
    <Layout>
      <div className="flex-1 p-6 background-light min-h-screen pt-30 overflow-hidden">

        {/* Page Heading */}
        <h1 className="text-2xl text-primary font-bold ml-0">{TrainingLabels.Training_Title} </h1>

        {/* Button */}
        <div className="flex justify-end mb-4">
          <Button
            type="primary"
            icon={<PlusOutlined />}

            onClick={showModal}
            className="text-white border p-4 bg-[var(--color-primary)]"
          >
           {TrainingLabels.Training_Add_Button}
          </Button>
        </div>


        {/* Create/Edit Form Modal */}
        {visible && (
          <AdminTrainingCreateEditForm
            visible={visible}
            setVisible={setVisible}
            onCreate={onCreate}
            onEdit={onEdit}
            selectedRecord={selectedRecord}
          />
        )}

        {/* Table Component with AdminTrainingListView Functionality */}
        <Spin spinning={loading} tip="Loading...">
        <AdminTrainingListView data={filteredData} onDelete={onDelete} onEdit={loadFormData} />
        </Spin>
      </div>

    </Layout>
  );

};
export default TrainingPortal;